<div class="flex h-full max-h-full min-h-0 w-full flex-col">
  <!-- header -->
  <div class="flex flex-col gap-3 px-6 sm:flex-row sm:items-start"
    [ngClass]="shortScreen ? 'pt-3 pb-2' : 'pt-6 pb-4'">
    <div class="flex min-w-0 flex-1 items-start gap-3">
      <mat-icon
        class="mt-1 shrink-0"
        [class.text-primary]="hasAnyCandidate"
        [class.text-amber-500]="!hasAnyCandidate"
        fontSet="material-icons-outlined"
        >{{ hasAnyCandidate ? 'alt_route' : 'warning' }}</mat-icon
      >
      <div class="min-w-0 flex-1">
        <h2 class="text-xl font-bold">{{ 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.TITLE' | t }}</h2>
        <!-- sin partición el motivo es uno solo y va aquí: no se oculta nunca porque no está en el detalle -->
        @if (!showsDocumentLabels) {
        <p class="text-secondary mt-1 leading-relaxed" [ngClass]="shortScreen ? 'text-sm' : 'text-base'">
          {{ groups[0]?.reason }}
        </p>
        } @else if (!shortScreen) {
        <p class="text-secondary mt-1 text-base leading-relaxed">
          {{ 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.SPLIT_SUBTITLE' | t: { count: groups.length } }}
        </p>
        }
      </div>
    </div>
    @if (canShowSplit) {
    <button mat-stroked-button color="primary" type="button" class="shrink-0" (click)="showSplit()">
      <mat-icon>call_split</mat-icon>
      {{ 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.VIEW_SPLIT' | t: { count: groups.length } }}
    </button>
    }
  </div>

  @if (showsDocumentLabels) {
  <!-- maestro y detalle: la lista crece con el número de documentos, el detalle no -->
  <div class="flex min-h-0 flex-1 flex-col border-t md:flex-row">
    <!-- móvil: el documento se elige en un desplegable -->
    <div class="shrink-0 border-b px-4 py-3 md:hidden">
      <mat-form-field class="w-full" subscriptSizing="dynamic">
        <mat-label>{{ 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.DOCUMENT_LABEL' | t }}</mat-label>
        <mat-select [value]="selectedIndex" (selectionChange)="select($event.value)"
          panelClass="dg-wrap-panel">
          <mat-select-trigger>
            @if (selected) {
            <span class="flex flex-wrap items-center gap-x-2 gap-y-0.5">
              <span class="font-semibold">{{ 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.DOCUMENT_NUMBERED' | t: { number: selected.index + 1 } }}</span>
              @if (!selected.candidates.length) {
              <span class="rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-semibold text-amber-700 dark:bg-amber-900/40 dark:text-amber-300">
                {{ 'DOCUMENT_GENERATE.BADGES.NO_ROUTE' | t }}
              </span>
              }
              @if (chosenRouteName(selected); as routeName) {
              <span class="text-secondary truncate text-xs">{{ routeName }}</span>
              } @else {
              <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.NO_ROUTE_ASSIGNED' | t }}</span>
              }
            </span>
            }
          </mat-select-trigger>
          @for (group of groups; track group.index) {
          <mat-option [value]="$index">
            <span class="flex flex-col gap-0.5 py-1">
              <span class="flex flex-wrap items-center gap-1.5">
                <span class="font-semibold">{{ 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.DOCUMENT_NUMBERED' | t: { number: group.index + 1 } }}</span>
                @if (!group.candidates.length) {
                <span class="rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-semibold text-amber-700 dark:bg-amber-900/40 dark:text-amber-300">
                  {{ 'DOCUMENT_GENERATE.BADGES.NO_ROUTE' | t }}
                </span>
                }
              </span>
              @if (group.warehouseLabel) {
              <span class="text-secondary text-xs uppercase">{{ group.warehouseLabel }}</span>
              }
              <span class="flex items-center gap-1 text-xs">
                @if (chosenRouteName(group); as routeName) {
                <mat-icon class="text-secondary icon-size-4" fontSet="material-icons-outlined"
                  >local_shipping</mat-icon
                >
                <span class="font-medium">{{ routeName }}</span>
                } @else {
                <span class="text-secondary">{{ 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.NO_ROUTE_ASSIGNED' | t }}</span>
                }
              </span>
            </span>
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <!-- desde md: lista de documentos como panel lateral -->
    <div
      class="hidden shrink-0 overflow-auto border-b md:block md:max-h-none md:w-72 md:border-b-0 md:border-r"
    >
      @for (group of groups; track group.index) {
      <button
        type="button"
        class="w-full border-b px-4 py-3 text-left transition-colors"
        [class.bg-primary-50]="$index === selectedIndex"
        [class.dark:bg-primary-900]="$index === selectedIndex"
        [class.hover:bg-gray-50]="$index !== selectedIndex"
        [class.dark:hover:bg-gray-800]="$index !== selectedIndex"
        (click)="select($index)"
      >
        <div class="flex items-center justify-between gap-2">
          <span class="truncate font-semibold" [class.text-primary]="$index === selectedIndex">
            {{ 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.DOCUMENT_NUMBERED' | t: { number: group.index + 1 } }}
          </span>
          @if (!group.candidates.length) {
          <span
            class="shrink-0 rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-semibold text-amber-700 dark:bg-amber-900/40 dark:text-amber-300"
          >
            {{ 'DOCUMENT_GENERATE.BADGES.NO_ROUTE' | t }}
          </span>
          }
        </div>
        @if (group.warehouseLabel) {
        <div class="text-secondary mt-0.5 truncate text-xs uppercase" [matTooltip]="group.warehouseLabel">
          {{ group.warehouseLabel }}
        </div>
        }
        <div class="mt-1 flex items-center gap-1 text-xs">
          @if (chosenRouteName(group); as routeName) {
          <mat-icon class="text-secondary icon-size-4" fontSet="material-icons-outlined"
            >local_shipping</mat-icon
          >
          <span class="truncate font-medium">{{ routeName }}</span>
          } @else {
          <span class="text-secondary">{{ 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.NO_ROUTE_ASSIGNED' | t }}</span>
          }
        </div>
      </button>
      }
    </div>

    <div class="min-h-0 min-w-0 flex-1 overflow-auto px-6 py-4">
      @if (selected) {
      <ng-container *ngTemplateOutlet="groupDetail; context: { $implicit: selected }"></ng-container>
      }
    </div>
  </div>
  } @else {
  <!-- documento único: el detalle ocupa todo el cuerpo, como antes de la partición -->
  <div class="min-h-0 flex-1 overflow-auto px-6 pb-4">
    @if (groups[0]) {
    <ng-container *ngTemplateOutlet="groupDetail; context: { $implicit: groups[0] }"></ng-container>
    }
  </div>
  }

  <!-- footer -->
  <div
    class="flex flex-wrap items-center justify-between gap-3 border-t bg-gray-50 px-6 dark:bg-transparent"
    [ngClass]="shortScreen ? 'py-2' : 'py-4'"
  >
    <span class="text-secondary text-sm">
      @if (showsDocumentLabels && documentsWithoutRoute.length) {
      {{ 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.WITHOUT_ROUTE_FOOTER' | t: { count: documentsWithoutRoute.length, total: groups.length } }}
      }
    </span>
    <div class="flex gap-3">
      <button mat-stroked-button type="button" (click)="cancel()">{{ 'GENERAL.CANCEL' | t }}</button>
      <button
        mat-flat-button
        color="primary"
        type="button"
        [disabled]="!canConfirm"
        (click)="confirm()"
      >
        {{ groups.length > 1 ? 'Generar documentos' : 'Generar documento' }}
      </button>
    </div>
  </div>
</div>

<!-- candidatas y descartes de un documento; el maestro y el caso sin partición lo comparten -->
<ng-template #groupDetail let-group>
  @if (showsDocumentLabels) {
  <div class="mb-4">
    <h3 class="text-base font-bold">{{ group.label }}</h3>
    <p class="text-secondary mt-1 text-base leading-relaxed">{{ group.reason }}</p>
  </div>
  }

  @if (group.candidates.length) {
  <p class="text-secondary mb-3 text-base leading-relaxed">
    {{ 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.SELECT_ROUTE' | t }}
  </p>
  <mat-radio-group class="flex flex-col gap-2" [(ngModel)]="selectedByDocument[group.index]">
    @for (candidate of group.candidates; track candidate._id) {
    <div
      class="rounded-xl border p-3 transition-colors"
      [class.border-primary]="selectedByDocument[group.index] === candidate._id"
      [class.bg-primary-50]="selectedByDocument[group.index] === candidate._id"
    >
      <mat-radio-button [value]="candidate._id" class="w-full">
        <div class="flex flex-col gap-1">
          <span class="font-bold uppercase">{{ candidate.name }}</span>
          @if (candidate.trip) {
          <span class="text-secondary text-sm">
            {{ 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.TRIP' | t }} <b>{{ candidate.trip.externalKeys?.code || candidate.trip.id }}</b>
            <span *ngIf="candidate.trip.description"> · {{ candidate.trip.description }}</span>
          </span>
          <span class="text-sm">
            {{ 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.DELIVERY' | t }}
            <b>{{ candidate.trip.dateHourStartTeoric | date:'dd/MM/yyyy HH:mm' }}</b>
            · {{ 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.LOAD' | t }}
            <b>{{ candidate.trip.loadDateTime | date:'dd/MM/yyyy HH:mm' }}</b>
          </span>
          }
          <!-- solo la cantidad: el viaje lo fija el endpoint, no se elige aquí -->
          @if (candidate.alternativeTrips.length) {
          <span class="text-secondary text-xs">
            {{ 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.ALTERNATIVE_TRIPS' | t: { count: candidate.alternativeTrips.length } }}
          </span>
          }
        </div>
      </mat-radio-button>
    </div>
    }
  </mat-radio-group>
  } @else {
  <!-- sin candidatas: el aviso manda -->
  <div
    class="flex items-start gap-3 rounded-xl border border-amber-300 bg-amber-50 p-4 dark:border-amber-700 dark:bg-amber-950"
  >
    <mat-icon class="text-amber-600 dark:text-amber-400" fontSet="material-icons-outlined"
      >info</mat-icon
    >
    <p class="text-base leading-relaxed text-amber-900 dark:text-amber-100">
      <span [innerHTML]="(showsDocumentLabels ? 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.CAN_GENERATE_THIS_DOC' : 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.CAN_GENERATE_THE_DOC') | t"></span>
    </p>
  </div>
  }

  @if (group.rejections.length) {
  <div class="mt-6 flex flex-col gap-5">
    <h3 class="text-base font-bold">{{ 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.REJECTIONS_TITLE' | t }}</h3>

    @for (rejection of group.rejections; track rejection.routeName) {
    <div class="overflow-hidden rounded-xl border">
      <!-- cabecera: ruta y motivo aplican a todo el bloque -->
      <div
        class="border-b border-amber-200 bg-amber-50 px-4 py-3 dark:border-amber-800 dark:bg-amber-950"
      >
        <div class="font-bold uppercase text-amber-900 dark:text-amber-100">
          {{ rejection.routeName }}
        </div>
        <div class="mt-1 text-sm leading-relaxed text-amber-800 dark:text-amber-200">
          {{ rejection.reason }}
        </div>
      </div>

      <!-- el choque: lo que la ruta ofrece contra lo que el documento exige -->
      <div class="grid gap-px bg-gray-200 sm:grid-cols-2 dark:bg-gray-700">
        @if (rejection.rejectedTrips.length) {
        <div class="bg-card px-4 py-3">
          <div class="text-secondary text-xs font-semibold uppercase">
            {{ 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.TRIPS_ON_ROUTE' | t }}
          </div>
          <div class="mt-1 flex flex-col gap-1">
            @for (trip of rejection.rejectedTrips; track trip._id) {
            <span class="text-sm">
              <b>{{ trip.dateHourStartTeoric | date:'dd/MM/yyyy' }}</b>
              <span class="text-secondary">
                {{ 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.TRIP_WEEKDAY_AT' | t: { weekday: tripWeekday(trip), time: (trip.dateHourStartTeoric | date:'HH:mm') } }}
              </span>
            </span>
            }
          </div>
        </div>
        } @if (rejection.effectiveWindow) {
        <div class="bg-card px-4 py-3">
          <div class="text-secondary text-xs font-semibold uppercase">
            {{ 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.COMMON_WINDOW' | t }}
          </div>
          <div class="mt-1 text-sm">
            @if (rejection.effectiveWindow.days.length) {
            <b>{{ effectiveDays(rejection.effectiveWindow) }}</b>
            <span class="text-secondary">
              {{ 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.FROM_TO' | t: { start: rejection.effectiveWindow.hourStart, end: rejection.effectiveWindow.hourEnd } }}
            </span>
            } @else {
            <b class="text-amber-700 dark:text-amber-300">{{ 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.NO_COMMON_DAY' | t }}</b>
            }
          </div>
          @if (rejection.effectiveWindow.hoursToDelivery) {
          <div class="text-secondary mt-1 text-sm">
            {{ 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.MIN_LEAD_HOURS' | t: { hours: rejection.effectiveWindow.hoursToDelivery } }}
          </div>
          }
          @if (rejection.effectiveWindow.restrictedBy.length) {
          <div class="mt-1 text-sm">
            <span class="text-secondary">{{ 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.RESTRICTED_BY' | t }} </span>
            <b>{{ restrictedByNames(rejection.effectiveWindow) }}</b>
          </div>
          }
        </div>
        }
      </div>

      @if (rejection.skippedHolidays.length) {
      <div class="border-b px-4 py-2 text-sm">
        <span class="text-secondary">{{ 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.SKIPPED_HOLIDAYS' | t }} </span>
        <b>{{ holidayList(rejection.skippedHolidays) }}</b>
      </div>
      }

      @if (rejection.materials.length) {
      <div class="overflow-x-auto">
        <table class="w-full min-w-[680px] border-collapse text-base">
          <thead>
            <tr class="text-secondary border-b text-left">
              <th class="px-4 py-2 text-xs font-medium uppercase">{{ 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.COL_ITEM' | t }}</th>
              <th class="px-4 py-2 text-xs font-medium uppercase">
                {{ 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.COL_SCHEDULE_SOURCE' | t }}
              </th>
              <th class="px-4 py-2 text-xs font-medium uppercase">{{ 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.COL_ALLOWED_DAYS' | t }}</th>
              <th class="px-4 py-2 text-xs font-medium uppercase">{{ 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.COL_SCHEDULE' | t }}</th>
            </tr>
          </thead>
          <tbody>
            @for (material of rejection.materials; track material._id) {
            <tr class="border-b last:border-b-0">
              <td class="px-4 py-2 align-top">
                <div class="flex flex-col">
                  <span class="text-secondary text-xs font-semibold">{{ material.code }}</span>
                  <span class="font-medium uppercase">{{ material.name }}</span>
                </div>
              </td>
              <td class="px-4 py-2 align-top text-sm">
                <b>{{ windowSourceLabel(material) }}</b>
              </td>
              <td class="px-4 py-2 align-top text-sm">{{ weekdayNames(material) || '—' }}</td>
              <td class="px-4 py-2 align-top text-sm">
                <span *ngIf="material.hourStart"
                  >{{ material.hourStart }}–{{ material.hourEnd }}</span
                >
                <span *ngIf="material.missingRequirements?.length">
                  Falta: <b>{{ requirementNames(material) }}</b>
                </span>
                <span *ngIf="!material.hourStart && !material.missingRequirements?.length">—</span>
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
      }
    </div>
    }
  </div>
  }
</ng-template>
